<template lang="pug">
    v-layout( justify-center row wrap )#layout-login
        //v-flex( xs11 sm8 md6 lg4 )
            v-card.grey.lighten-4
                v-card-title( primary-title ).subheading.text-uppercase.font-weight-medium Iniciar sesión
                v-card-text.py-4
                    v-form
                        v-text-field( 
                            disabled
                            label='Token *'
                            loading
                            placeholder='Token de punto de venta'
                            required 
                            )
                v-card-actions.justify-end( justify-end )
                    v-btn( color='success' loading ) acceder

        v-flex( xs12 sm10 md8 lg6 xl5 )
            v-card.card-login.pa-4( :disabled='requesting' )
                v-card-title.headline.pt-2 Iniciar sesión
                v-card-text.py-0
                    v-form
                        v-text-field(
                            v-model='token' 
                            label='Ingrese token de estación de trabajo *' 
                            @input="$v.token.$touch()" 
                            @blur="$v.token.$touch()" 
                            :disabled='requesting'
                            :error-messages="tokenError"
                            :loading='requesting'
                            required
                            :color="colors.primary"
                            )
                v-card-actions.px-3.pt-4
                    v-btn.px-4( 
                        type="button" 
                        color='success' 
                        :loading='requesting'
                        v-on:click="login" 
                        ) acceder
</template>

<script>
import { getAndSaveLoginToken } from '@/services/auth/AuthService'
import { mapActions } from 'vuex'
import colors from '@/mixins/Colors'
import { validationMixin } from 'vuelidate'
import { required, email, minLength } from 'vuelidate/lib/validators'

export default {
    name: 'login',
    data() {
        return {
            token: '',
            bRejectLoginByServer: false,
            requesting: false,
        }
    },
    mixins: [validationMixin],
    validations: {
        token: {
            required,
            bCorrectLoginByServer(value) {
                return !this.bRejectLoginByServer
            },
        },
    },
    computed: {
        tokenError() {
            const errors = []
            if (!this.$v.token.$dirty) return errors
            !this.$v.token.required && errors.push('El token es obligatorio.')
            !this.$v.token.bCorrectLoginByServer &&
                errors.push('El token ingresado es incorrecto.')
            this.bRejectLoginByServer = false
            return errors
        },
    },
    methods: {
        login: function() {
            this.$v.$touch()
            if (!this.$v.$error) {
                this.requesting = true
                getAndSaveLoginToken(this.token)
                    .then(() => {
                        this.$router.push('/')
                    })
                    .catch(err => {
                        // Show error below input email
                        this.bRejectLoginByServer = true
                        this.tokenError
                    })
                    .then(() => {
                        this.requesting = false
                    })
            } // end if
        }, // end function
    },
}
</script>
    
<style lang="scss" scoped>
#layout-login {
    /* Bg Image */
    background-image: url('../../assets/bg-agro.jpg');
    background-size: 100% 100%;
    height: 100%;
}

#layout-login::before {
    content: '';
    background-color: rgba(0, 0, 0, 0.6);
    position: absolute;
    width: 100%;
    height: 100%;
}

.card-login {
    margin-top: 20%;
    background-color: rgba(255, 255, 255, 0.85) !important;
}

a {
    color: darkcyan;
}
</style>
